import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { DownloadAppButtonsComponent } from '../download-app-buttons/download-app-buttons.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';
@Component({
    selector: 'app-download-app-notification',
    templateUrl: './download-app-notification.component.html',
    styleUrls: ['./download-app-notification.component.scss'],
    standalone: true,
    imports: [DownloadAppButtonsComponent, MatButton]
})
export class DownloadAppNotificationComponent implements OnInit, AfterViewInit {
  topImage = './../../../../../assets/images/backgrounds/components/top_image.png';
  bottomImage = './../../../../../assets/images/backgrounds/components/bottom_image.png';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<any>) {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    const backdropEl = document.querySelector('.cdk-overlay-pane .mat-mdc-dialog-surface');
    backdropEl.classList.add('padding_none');
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
